import React, { useState, useEffect } from 'react';
import GatherLensApp from './components/GatherLensApp';
import { auth } from './firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

const AUTH_FALLBACK_TIMEOUT_MS = 5000;

function App() {
  const [authReady, setAuthReady] = useState(false);
  const [authState, setAuthState] = useState({ user: null, error: null, forcedReady: false });

  useEffect(() => {
    let isMounted = true;

    const timeoutId = window.setTimeout(() => {
      if (!isMounted) return;
      setAuthReady(true);
      setAuthState(prev => ({ ...prev, forcedReady: true }));
    }, AUTH_FALLBACK_TIMEOUT_MS);

    const unsubscribe = onAuthStateChanged(
      auth,
      (currentUser) => {
        if (!isMounted) return;
        window.clearTimeout(timeoutId);
        setAuthState({ user: currentUser, error: null, forcedReady: false });
        setAuthReady(true);
      },
      (error) => {
        if (!isMounted) return;
        console.error('Error while initializing Firebase auth:', error);
        window.clearTimeout(timeoutId);
        setAuthState({ user: null, error, forcedReady: false });
        setAuthReady(true);
      }
    );

    return () => {
      isMounted = false;
      window.clearTimeout(timeoutId);
      unsubscribe();
    };
  }, []);

  if (!authReady) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-white transition-colors">
        <div className="h-16 w-16 border-4 border-white/20 border-t-white rounded-full animate-spin mb-6" aria-hidden="true" />
        <p className="text-lg font-semibold">Loading GatherLens…</p>
        <p className="mt-2 text-sm text-white/70 max-w-xs text-center">
          We&apos;re preparing your experience. This usually takes just a moment.
        </p>
      </div>
    );
  }

  return (
    <GatherLensApp
      initialUser={authState.user}
      authError={authState.error}
      authFallbackTriggered={authState.forcedReady}
    />
  );
}

export default App;